import React from 'react';
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {Container} from "react-bootstrap";

class ConfirmEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            user: null
        };
    }

    componentDidMount() {
        const { navigate } = this.props;

        if (this.props.email && this.props.token) {
            fetch(process.env.REACT_APP_API_URL + '/my-account/confirm-email/' + this.props.email + '/' + this.props.token, {
                method: "GET",
                headers: {'Content-Type': 'application/json'}
            }).then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            user: result
                        });
                    },
                    (error) => {
                        navigate('/login');

                        this.setState({
                            isLoaded: false,
                            error,
                        });
                    }
                );
        }
    }

    render() {
        const { error } = this.state;

        var content = null;

        if (error) {
            content = <h1>Token has expired or email is invalid</h1>
        } else {
            content = <div>
                <h1>Email confirmed successfully</h1>
                <br/>
                <NavLink className="btn btn-outline-primary"
                    to={"/account"}
                >
                    Go to my account
                </NavLink>
            </div>;
        }

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(ConfirmEmail);
